import React from 'react';
import '../App.css';

const About: React.FC = () => {
  return (
    <div className="page-content">
      <h1>Despre aceasta aplicatie</h1>
      <div className="content-box">
        <h2>Tehnologii utilizate</h2>
        <ul className="tech-list">
          <li><strong>Frontend:</strong> React 18 + TypeScript</li>
          <li><strong>Rutare:</strong> React Router v6</li>
          <li><strong>Backend:</strong> PHP</li>
          <li><strong>Stilizare:</strong> CSS3 cu gradiente si glassmorphism</li>
        </ul>
        
        <h2>Functionalitati</h2>
        <ul className="tech-list">
          <li>✅ Rutare client-side cu React Router</li>
          <li>✅ Parametri de ruta pentru pagini dinamice</li>
          <li>✅ Integrare API cu backend PHP</li>
          <li>✅ TypeScript pentru siguran\u021ba tipurilor</li>
          <li>✅ UI modern si responsiv</li>
        </ul>
      </div>
    </div>
  );
};

export default About;
